import { render, staticRenderFns } from "./waterAffairs.vue?vue&type=template&id=10de5516&scoped=true"
import script from "./waterAffairs.vue?vue&type=script&lang=js"
export * from "./waterAffairs.vue?vue&type=script&lang=js"
import style0 from "./waterAffairs.vue?vue&type=style&index=0&id=10de5516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de5516",
  null
  
)

export default component.exports